// extracted by mini-css-extract-plugin
export default {"img":"ProductPage_img__F5y1w","info":"ProductPage_info__Z-gIi","info__name":"ProductPage_info__name__GgTyj","info__long_description":"ProductPage_info__long_description__RZoTI"};